import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { apiService } from '../../../../service/api.service';
import { ResponseCuentasModel, CuentasModel } from 'src/app/model/Cuentas.model';
import { Subscription } from 'rxjs';
import { JardinModel } from 'src/app/model/Jardin.model';


@Component({
  selector: 'app-administracion',
  templateUrl: './administracion.component.html',
  styleUrls: ['./administracion.component.css']
})
export class AdministracionComponent implements OnInit {
 
  verOtrosPerfiles = false;
  verInicioCronograma = false;
  verEncargadosRegionales = false;
  dataSelects = new CuentasModel();
  showSimulacion : boolean;
  jardinSeleccionado: JardinModel;


  constructor(
    private api: apiService
  ) { }

  ngOnInit(): void {
    this.showSimulacion = false;
    this.getSelectCuentas();
  }



  getSelectCuentas(){
    this.api.API_POST_getSelectCuentas().subscribe((response: ResponseCuentasModel) => {
      this.dataSelects = response.payload
    },
    (err) => {
      console.log(err)
    })
  }
 

}
